import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import "../../cssfiles/homepage.css";
import { getuserlistorganization, deleteuser } from "../../Restclient/datacollection";
import {updateuserslist} from "../../store/cofig_data";
import { useDispatch, useSelector } from "react-redux";
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

export default function Userdisplay (props) {
    const dispatch = useDispatch()
    const userlistfromserver = useSelector((state) => state.configdata.userslist)
    const theme = useSelector((state) => state.themedata.theme)

    const [userlist, setUserlist] = useState([])
    const [deleteusername, setDeleteusername] = useState({})
    const [dialogflag, setDialogflag] = useState(false)
    const [dialogsecflag, setDialogsecflag] = useState(false)
    const [msg, setMsg] = useState("")

    const usercallback = (res) => {
       
        dispatch(updateuserslist(res.data))
        setUserlist(res.data)
    }

    useEffect(() => {
 
        if(props.projname === "All") {
            getuserlistorganization(props.orgname, props.projname, usercallback)
        } else {
            getuserlistorganization(props.orgname, props.projname, usercallback)
        }
    },[])

    useEffect(() => {
      
        if(props.projname === "All") {
            getuserlistorganization(props.orgname, props.projname, usercallback)
        } else {
            getuserlistorganization(props.orgname, props.projname, usercallback)
        }
    },[props.orgname, props.projname])

    useEffect(() => {
        if(userlistfromserver != undefined) {
            setUserlist(userlistfromserver)
        }
    },[userlistfromserver])

    const handleeditclick = (user) => {
        props.callbackedit(user)
    }

    const handledeleteclick = (user) => {
        console.log("delete user ",user)
        setDeleteusername(user)
        setDialogflag(true)
    }

    const handleClosedialog = () => {
        setDialogflag(false)
    }

    const callbackuserdelete = (res) => {
        if(res.status === "done") {
            setMsg("User deleted Successfully")
            setDialogsecflag(true)
            dispatch(updateuserslist(res.data.users.data))
        } else {
            setMsg("Error in deleting User")
            setDialogsecflag(true)
        }
    } 

    const handledeletdialog = () => {
        console.log("deleteuser ", deleteusername,props)
        var usedatails={
            "UserName": deleteusername.UserName,
            "Email": deleteusername.Email,
            "Mobile": deleteusername.Mobile,
            "Address": deleteusername.Address,
            "Discription": deleteusername.Discription,
            "State": true,
            "Permission": deleteusername.Permission,
            "Groupname": deleteusername.Groupid,
            "Orgname": props.orgname,
            "Project": "All"
        }
        deleteuser(usedatails,callbackuserdelete)
        setDialogflag(false)
    }

    const handleClosedialogsec = () => {
        setDialogsecflag(false)
    }
    return(
        <div style={{  width: '100%', height: '100%'}}>
            <table width={'100%'} align='left' className='scope1-config-table' style={{ margin: '0 0 20px 0', padding: '0', borderSpacing: 0, borderCollapse: 'collapse', overflow: 'auto' }}>
                <tr className='scope1-config-table-heading'>
                    <td>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            User Name
                        </Typography>
                    </td>
                    <td>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            Email
                        </Typography>
                    </td>
                    <td>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            Mobile
                        </Typography>
                    </td>
                    <td>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            Address
                        </Typography>
                    </td>
                    <td>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            Discription
                        </Typography>
                    </td>
                    <td>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            User Group
                        </Typography>
                    </td>
                    <td>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            User Permissions
                        </Typography>
                    </td>
                    <td colSpan={2}>
                        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
                            Actions
                        </Typography>
                    </td>
                </tr>
                {
                    userlist.map((user) => {
                        return(
                            <tr>
                                <td>
                                    <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
                                        {user.UserName}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
                                        {user.Email}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
                                        {user.Mobile}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
                                        {user.Address}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
                                        {user.Discription}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
                                        {user.Groupid}
                                    </Typography>
                                </td>
                                <td>
                                    <Typography className='emission-config-metric' style={{ fontSize: '14px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
                                        {user.Permission}
                                    </Typography>
                                </td>
                                <td align="left">
                                    <span onClick={() => handleeditclick(user)} style={{ fontSize: '12px', fontWeight: 400, color: 'var(--HighlightedText_Stroke)', fontFamily: 'Roboto', textAlign: 'left', cursor: 'pointer', pointerEvents: props.addtrigger ? 'none': 'auto'}} > Edit </span>
                                </td>
                                <td align="left">
                                    <span onClick={() => handledeleteclick(user)} style={{ fontSize: '12px', fontWeight: 400, color: 'var(--HighlightedText_Stroke)', fontFamily: 'Roboto', textAlign: 'left', cursor: 'pointer',pointerEvents: props.addtrigger ? 'none': 'auto' }}> Delete </span>
                                </td>
                            </tr>
                        )
                    })
                }
                
            </table>

            <Dialog
                open={dialogflag}
                onClose={handleClosedialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { borderRadius: "0px" } }}
            >
                <DialogTitle id="alert-dialog-title" style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    {"Conformation Info"}
                </DialogTitle>
                <DialogContent style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    Do you want to delete {deleteusername.hasOwnProperty("UserName") ? deleteusername.UserName : ""} user ?
                </DialogContent>
                <DialogActions style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    <button 
                        style={{
                            padding: '6px 15px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: 'transparent',
                            color: '#7E7E7E',
                            //padding: '8px 45px',
                            border: '1px solid',
                            borderColor:theme === 'dark' ? '#7E7E7E' : '#7E7E7E',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                            marginRight: '10px'
                        }}
                        onClick={handleClosedialog}
                    >
                        Close
                    </button>
                    <button 
                        style={{
                            padding: '8px 20px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: '#005C8E',
                            color: '#FFFFFF',
                            //padding: '8px 45px',
                            border: 'none',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                        }}
                        onClick={handledeletdialog}
                    >
                        Delete
                    </button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogsecflag}
                onClose={handleClosedialogsec}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { borderRadius: "0px" } }}
            >
                
                <DialogContent style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    {msg}
                </DialogContent>
                <DialogActions style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    <button 
                        style={{
                            padding: '6px 15px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: 'transparent',
                            color: '#7E7E7E',
                            //padding: '8px 45px',
                            border: '1px solid',
                            borderColor:theme === 'dark' ? '#7E7E7E' : '#7E7E7E',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                            marginRight: '10px'
                        }}
                        onClick={handleClosedialogsec}
                    >
                        Close
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    )
}